/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	modalButton: {
		border: 'none',
		height: '14px',
		lineHeight: '14px',
		padding: '0px',
		verticalAlign: 'baseline'
	}
});

export default styles;
